<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer007">
<p class="pl-title"><a id="_idTextAnchor001"></a>THE CAPTAIN’S CHRISTMAS JOURNEY</p>
<p class="pl-author">Carla Kelly</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// The_Captains_Christmas_Journey.vue?493fd5c9